import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Toaster from "../components/Toaster";
import MessageSegments from "../components/MessageSettings/MessageSegments";
import MessageGroups from "../components/MessageSettings/MessageGroups";
import DeclineReasons from "../components/MessageSettings/DeclineReason";
import PlusIMg from "../assets/images/plus.png";
import PlusIMgDark from "../assets/images/plusDark.png";

import { toast } from "react-toastify";
import { getAllMessageSegments } from "../redux/actions/messageSegmentSettings";

const MessageSettings = () => {
  const [tab, setTab] = useState(1);
  const [openFormType, setOpenFormType] = useState("");
  const [openForm, setOpenForm] = useState(false);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const dispatch = useDispatch();

  const messageSegmentsSettings = useSelector(
    (state) => state.messageSegmentsSettings
  );
  const { loading, messageSegments } = messageSegmentsSettings;

  const messageGroupsSettings = useSelector(
    (state) => state.messageGroupsSettings
  );
  const { loading: loading2, messageGroups } = messageGroupsSettings;

  const handleOpenForm = (title, type) => {
    if (userInfo?.planNo < 5) {
      toast.info(`Please upgrade your account to create Message ${title}!`);
      return true;
    }
    setOpenForm(true);
    setOpenFormType(type);
  };

  useEffect(() => {
    dispatch(getAllMessageSegments(0, 10));
  }, [dispatch]);

  return (
    <>
      <div className="container messageSettingsWrapers">
        <ul className="tabs">
          <li
            className={tab === 1 ? "tab-link current" : "tab-link"}
            data-tab="tab-3"
            onClick={(e) => setTab((val) => 1)}
          >
            Message Segments
          </li>
          <li
            className={tab === 2 ? "tab-link current" : "tab-link"}
            data-tab="tab-1"
            onClick={(e) => setTab((val) => 2)}
          >
            Message Groups
          </li>

          <li
            className={tab === 3 ? "tab-link current" : "tab-link"}
            data-tab="tab-1"
            onClick={(e) => setTab((val) => 3)}
          >
            Declined Reason
          </li>
          {(tab === 1 && !loading && messageSegments?.length > 0) ||
          (tab === 2 && !loading2 && messageGroups?.length > 0) ? (
            <button
              style={{ float: "right" }}
              className="createButton gmNewBtn Lists"
              id="autometion-create-btn"
              onClick={() => {
                if (userInfo?.planNo < 5) {
                  toast.info(
                    `Please upgrade your account to create Message ${
                      tab === 1 ? "Segment" : "Group"
                    }!`
                  );
                  return true;
                }
                setOpenForm(() => true);
                setOpenFormType(tab === 1 ? "messageSegment" : "messageGroup");
              }}
            >
              <img src={PlusIMgDark} className="plusImg" alt="" />
              {tab === 1 ? "Add Segment" : "Add Group"}
            </button>
          ) : (
            ""
          )}
        </ul>

        {tab === 1 && (
          <MessageSegments
            tab={tab}
            openForm={openForm && openFormType === "messageSegment"}
            setOpenForm={(val) => {
              setOpenForm(val);
              setOpenFormType(val === true ? "messageSegment" : "");
            }}
            handleOpenForm={() => handleOpenForm("Segment", "messageSegment")}
          />
        )}
        {tab === 2 && (
          <MessageGroups
            tab={tab}
            openForm={openForm && openFormType === "messageGroup"}
            setOpenForm={(val) => {
              setOpenForm(val);
              setOpenFormType(val === true ? "messageGroup" : "");
            }}
            handleOpenForm={() => handleOpenForm("Group", "messageGroup")}
          />
        )}
        {tab === 3 && <DeclineReasons userInfo={userInfo} />}
      </div>
      <Toaster />
    </>
  );
};

export default MessageSettings;
